import { Slider as NSlider, type SliderProps as Props } from '@heroui/react';
import { type Control, Controller, type FieldValues, type Path, type PathValue } from 'react-hook-form';

export const Slider = (
  props: Props & {
    className?: string;
    showSteps?: boolean;
    fillOffset?: number;
    renderLabel?: (props: React.ComponentProps<'span'>) => React.ReactNode;
  },
) => {
  return <NSlider {...props} />;
};

export interface FormSliderProps<T extends FieldValues> extends React.ComponentProps<typeof Slider> {
  name: Path<T>;
  className?: string;
  control: Control<T, unknown>;
  defaultValue?: PathValue<T, Path<T>>;
}

export const FormSlider = <T extends FieldValues>({
  control,
  name,
  defaultValue,
  className,
  ...rest
}: FormSliderProps<T>) => {
  return (
    <Controller
      name={name}
      defaultValue={defaultValue}
      control={control}
      shouldUnregister
      render={({ field: { onChange, value } }) => {
        return (
          <Slider
            {...rest}
            className={className}
            value={value}
            // isInvalid={isDirty && invalid}
            onChange={onChange}
          />
        );
      }}
    />
  );
};
